namespace $ {
	const { rem, em, px, per } = $mol_style_unit
	const { hsla } = $mol_style_func

	const border_width = px(1)
	$mol_style_define($exso_table, {
		Item: {
			alignItems: 'initial',
		},
		Content: {
			border: {
				width: border_width,
				style: 'solid',
				color: $mol_theme.text,
				left: { style: 'none' },
			},
			margin: { top: $mol_gap.block },
			'>': {
				$mol_view: {
					':not([exso_table_total])': {
						flexWrap: 'wrap',
						color: 'inherit',
						padding: 0,
						gap: border_width,
						background: { color: $mol_theme.line },
						border: {
							color: $mol_theme.line,
							left: { width: $mol_gap.space, style: 'solid', color: hsla($mol_theme.hue, 100, 50, 1) },
							top: { width: border_width, style: 'solid' },
							radius: 0,
						},
						...Object.fromEntries(
							[':hover', ':focus-visible'].map(k => [
								`[mol_link]${k}`,
								{
									background: { color: $mol_theme.current },
									border: {
										color: $mol_theme.current,
										left: { color: hsla($mol_theme.hue, 100, 50, 1) },
									},
									'+ *': {
										border: {
											top: { color: $mol_theme.current },
										},
									},
								},
							]),
						),

						$mol_labeler: {
							background: { color: $mol_theme.card },
						},

						':nth-of-type(even)': {
							$mol_labeler: {
								background: { color: $mol_theme.back },
							},
						},
						':nth-of-type(3n)': {
							'--mol_theme_hue': '240deg',
						},
						':nth-of-type(3n+1)': {
							'--mol_theme_hue': '0deg',
						},
						':nth-of-type(3n+2)': {
							'--mol_theme_hue': '120deg',
						},
					},
				},
			},
		},
		Total: {
			padding: 0,
			gap: border_width,
			fontWeight: 'bold',
			overflow: 'hidden',
			background: { color: $mol_theme.back },
			border: {
				color: $mol_theme.text,
				left: { width: $mol_gap.space, style: 'solid' },
			},
			$mol_labeler: {
				background: { color: $mol_theme.line },
			},
			alignItems: 'initial',
		},
		Column: {
			flex: { shrink: 1, grow: 1, basis: rem(8) },
			Content: {
				paddingTop: '0',
				minHeight: 'auto',
			},
		},
		Column_contents: {
			padding: $mol_gap.block,
			paddingTop: '0',
			// padding: { top: 0 },
			gap: [0, $mol_gap.space],
		},
		Column_content: {
			':first-of-type': {
				font: { weight: 500 },
			},
			':nth-of-type(even)': {
				color: $mol_theme.shade,
			},
			':hover': {
				background: { color: $mol_theme.line },
			},
		},
	})
}
